export default {
  baseURL:process.env.TIO_BOOT_ADMIN_BACKEND_URL,
}
